// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--kg00a","label":"_4f720283bf--label--M0ezx","btns":"_4f720283bf--btns--m8Z9k","mobile":"_4f720283bf--mobile--gOb4T"};